export default "__VITE_ASSET__C8hKeC9F__"